import * as yup from 'yup';
import { site } from '@panel/commons/helpers';

const REGEX_CEP = /[0-9]{5}-?[\d]{3}/;

const step1Module2Schema = yup.object().shape({
  addressVal: yup.string().when('$disableChanges', {
    is: false,
    then: yup.string().required(),
    otherwise: yup.string().notRequired()
  }),
  cep: yup
    .string()
    .matches(REGEX_CEP, { excludeEmptyString: true })
    .notRequired(),
  addressComplement: yup
    .string()
    .max(40, 'publisher.step1.module2.complement.error')
    .notRequired(),
  provinceVal: yup.string().required(),
  cityVal: yup.string().required(),
  districtIsRequired: yup.string(),
  districtVal: yup.string().when('$validateDistrict', (validateDistrict, schema) => {
    return validateDistrict && site.id !== 'ZPAR' ? schema.trim().required() : schema.notRequired();
  }),
  subDistrictVal: yup.string().notRequired()
});

export { step1Module2Schema };
